import { render, staticRenderFns } from "./treatyengine.vue?vue&type=template&id=2695b2e9&scoped=true&"
import script from "./treatyengine.vue?vue&type=script&lang=js&"
export * from "./treatyengine.vue?vue&type=script&lang=js&"
import style0 from "./treatyengine.vue?vue&type=style&index=0&id=2695b2e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695b2e9",
  null
  
)

export default component.exports